import React, { useEffect, useState } from "react";
import { fmtIST } from "../lib/time";
import { api } from "../lib/api";
import { usePager } from "../components/Pagination";
import PageHeader from "../components/PageHeader";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/audit-log").then((r) => setRows(r.data)).catch(() => {});
  }, []);
  // Wave-J pagination
  const { visibleRows: pagedRows, controls: pageControls } = usePager(rows, 10);
  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Immutable trail of all state changes" />
      <div className="p-8">
        <div className="bg-white border border-[#EEEEEE] rounded-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F5F5F5] text-[10px] uppercase tracking-widest text-[#0D2B5E]/60">
              <tr>
                <th className="text-left px-4 py-2">Timestamp</th>
                <th className="text-left px-4 py-2">User</th>
                <th className="text-left px-4 py-2">Role</th>
                <th className="text-left px-4 py-2">Module</th>
                <th className="text-left px-4 py-2">Action</th>
                <th className="text-left px-4 py-2">Record</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map((r, i) => (
                <tr key={r.id} className={i % 2 === 0 ? "bg-white" : "bg-[#F5F5F5]/40"}>
                  <td className="px-4 py-2 font-mono text-xs">{fmtIST(r.timestamp)}</td>
                  <td className="px-4 py-2 text-xs">{r.user_name}</td>
                  <td className="px-4 py-2 text-xs uppercase tracking-widest text-[#1565C0]">{r.role_name || "—"}</td>
                  <td className="px-4 py-2 text-xs uppercase tracking-widest">{r.module}</td>
                  <td className="px-4 py-2 text-xs uppercase tracking-widest text-[#E65100]">{r.action}</td>
                  <td className="px-4 py-2 font-mono text-xs">{r.record_id?.slice(0, 8)}…</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-[#0D2B5E]/50">No audit entries (Super Admin only view).</td></tr>}
            </tbody>
          </table>
          {pageControls}
        </div>
      </div>
    </div>
  );
}
